<template>
    <div class="page_container work_order_visual_charts">
        <div class="work_order_visual_charts_header">
            <ul class="show_type_btn_wrap">
                <li :class="{ active: showType === 'calendar' }" @click="changeShowType('calendar')">日历</li>
                <li :class="{ active: showType === 'ganttChart' }" @click="changeShowType('ganttChart')">甘特图</li>
            </ul>
            <el-select v-model="workOrderType" placeholder="工单类型筛选" size="small">
                <el-option
                    v-for="(type, typeIndex) in workOrderTypeOptions"
                    :key="typeIndex"
                    :label="type.label"
                    :value="type.value"
                ></el-option>
            </el-select>
            <el-select
                size="small"
                v-model="role_range_text"
                multiple
                collapse-tags
                placeholder="人员筛选"
                popper-class="selectPopperHideClass"
                @focus="handleCreatorSelectFocus"
            >
            </el-select>
        </div>
        <div class="work_order_visual_charts_content work_order_calendar_content" v-if="showType === 'calendar'">
            <div class="visual_charts_filter_wrap">
                <div class="visual_charts_filter_wrap_left">
                    <el-button size="small">今日</el-button>
                    <el-date-picker
                        v-model="date"
                        size="small"
                        type="date"
                        format="yyyy/MM/dd"
                        value-format="yyyy/MM/dd"
                        placeholder="选择日期"
                        :clearable="false"
                    ></el-date-picker>
                </div>
                <div class="visual_charts_filter_wrap_right">
                    <span :class="{ active: calendarType == 'day' }" @click="handleClickChangeCalendarType('day')"
                        >日</span
                    >
                    <span :class="{ active: calendarType == 'week' }" @click="handleClickChangeCalendarType('week')"
                        >周</span
                    >
                    <span :class="{ active: calendarType == 'month' }" @click="handleClickChangeCalendarType('month')"
                        >月</span
                    >
                </div>
            </div>
            <div class="visual_charts_date_wrap">
                <div class="visual_charts_date_left"></div>
                <div class="visual_charts_date_right"></div>
            </div>
            <div class="visual_charts_content_wrap visual_charts_calendar_content_wrap">
                <div class="visual_charts_content_left">
                    <p v-for="(time,timeIndex) in hours24Pad" :key="timeIndex">{{ time }}</p>
                </div>
                <div class="visual_charts_content_right"></div>
            </div>
        </div>
        <div class="work_order_visual_charts_content work_order_ganttChart_content" v-else>
            <div class="visual_charts_date_wrap">
                <div class="visual_charts_date_left">
                    <el-button size="small">今日</el-button>
                </div>
                <div class="visual_charts_date_right"></div>
            </div>
            <div class="visual_charts_content_wrap">
                <div class="visual_charts_content_left"></div>
                <div class="visual_charts_content_right"></div>
            </div>
        </div>
        <userDepartmentSelection
            :userDepartmentVisible.sync="userDepartmentVisible"
            v-if="userDepartmentVisible"
            :userDepartmentSelected="selected_users"
            :userDepartmentTitle="'人员筛选'"
            :type="'userDepartment'"
            :checkStrictly="true"
            @success="userDepartmentSuccess"
        />
    </div>
</template>
<script>
import userDepartmentSelection from "@/components/pComponents/userDepartmentSelection.vue";
export default {
    name: "WorkOrderVisualCharts",
    data() {
        return {
            showType: "calendar",
            workOrderType: "",
            role_range_text: [],
            selected_users: [],
            calendarType: "day",
            date: "2025/03/01",

            workOrderTypeOptions: [{ label: "全部", value: "" }],
            userDepartmentVisible: false,
            hours24Pad: []
        };
    },
    components: { userDepartmentSelection },
    created() {
        this.hours24Pad = this.getHours24Pad()
    },
    methods: {
        changeShowType(type) {
            this.showType = type;
        },
        // 选择人员
        handleCreatorSelectFocus() {
            this.userDepartmentVisible = true;
        },
        // 选择部门人员回调
        userDepartmentSuccess(data) {
            this.selected_users = data;
            this.role_range_text = data.map((item) => item.relate_name);
        },
        // 日历筛选
        handleClickChangeCalendarType(type) {
            this.calendarType = type;
        },
        // 获取24小时时间
        getHours24Pad() {
            const times = Array.from({ length: 24 }, (_, i) => {
                const hour = i + 1;
                return `${hour.toString().padStart(2, "0")}:00`;
            });
            return times
        },
    },
};
</script>
<style lang="scss" scoped>
.work_order_visual_charts {
    gap: 4px;
    overflow: hidden;
    .work_order_visual_charts_header {
        display: flex;
        gap: 16px;
        .show_type_btn_wrap {
            height: 32px;
            border-radius: 4px;
            background-color: #ffffff;
            display: flex;
            overflow: hidden;
            li {
                width: 74px;
                height: 32px;
                text-align: center;
                line-height: 32px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);
                &.active {
                    background-color: rgba(41, 144, 255, 1);
                    font-weight: 700;
                    color: rgba(255, 255, 255, 1);
                }
                cursor: pointer;
            }
        }
    }
    .work_order_visual_charts_content {
        height: calc(100% - 36px);
        border-radius: 6px;
        background: rgba(255, 255, 255, 1);
        display: flex;
        flex-direction: column;
        .visual_charts_filter_wrap {
            flex-shrink: 0;
            height: 56px;
            border-bottom: 1px solid rgba(0, 0, 0, 0.08);
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
        .visual_charts_filter_wrap_left {
            display: flex;
            align-items: center;
            gap: 16px;
            ::v-deep .el-date-editor {
                width: 108px;
                &:hover,
                &:focus {
                    .el-input__prefix {
                        background: rgba(0, 0, 0, 0.04);
                    }
                }
                .el-input__prefix {
                    width: 0;
                    opacity: 0;
                    &:hover,
                    &:focus {
                        background: rgba(0, 0, 0, 0.04);
                    }
                }
                .el-input__inner {
                    padding: 0 8px;
                }
            }
        }
        .visual_charts_filter_wrap_right {
            width: 184px;
            height: 32px;
            line-height: 32px;
            padding: 2px;
            border-radius: 4px;
            background: rgba(237, 240, 244, 1);
            box-sizing: border-box;
            display: flex;
            span {
                flex: 1;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                color: rgba(102, 102, 102, 1);
                border-radius: 4px;
                text-align: center;
                height: 28px;
                border-radius: 4px;
                cursor: pointer;

                &:hover {
                    color: rgba(51, 51, 51, 1);
                    background: rgba(0, 0, 0, 0.04);
                }
                &.active {
                    color: rgba(51, 51, 51, 1);
                    font-weight: 700;
                    background: rgba(255, 255, 255, 1);
                }
            }
        }
    }
    .visual_charts_date_wrap {
        display: flex;
        height: 50px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        .visual_charts_date_left {
            width: 92px;
            background: rgba(0, 0, 0, 0.04);
        }
        .visual_charts_date_right {
            flex: 1;
            background-color: #ffffff;
        }
    }
    .visual_charts_content_wrap {
        flex: 1;
        display: flex;
        overflow: hidden;
        .visual_charts_content_left {
            width: 92px;
            height: 100%;
            background: rgba(0, 0, 0, 0.04);
            overflow-y: auto;
        }
        .visual_charts_content_right {
            flex: 1;
            height: 100%;
            background-color: #ffffff;
            overflow-y: auto;
        }
    }
    .work_order_calendar_content {
        .visual_charts_content_left {
            padding: 28px 0 0;
            p {
                font-size: 12px;
font-weight: 400;
letter-spacing: 0px;
line-height: 18px;
text-align: center;
color: rgba(153, 153, 153, 1);
margin-bottom: 18px;
            }
        }
    }
    .work_order_ganttChart_content {
        .visual_charts_date_left {
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}
</style>
